class VgLogs {
    constructor() {
    }

	async storeOnLogInitPaymentProcess(progress) {
		let quote_selected = {};
		let addons_selected = {};

		if (progress.getSelectQuoteStep().data["vg-select-quote"]) {
			if (progress.getSelectQuoteStep().data["vg-select-quote"][0].globalId) {
				quote_selected.global_Id = progress.getSelectQuoteStep().data["vg-select-quote"][0].globalId;
			}

			if (progress.getSelectQuoteStep().data["vg-select-quote"][0].value) {
				quote_selected.value = progress.getSelectQuoteStep().data["vg-select-quote"][0].value;
			}
		}

		if (progress.getSelectQuoteStep().data["vg-select-quote--addons"]) {
			progress.getSelectQuoteStep().data["vg-select-quote--addons"]?.forEach((addOn, index) => {
				addons_selected[index] = {};
				addons_selected[index].global_Id = addOn.globalId;
				addons_selected[index].value = addOn.value;

			});
		}

		let data = {
			'log': 'storeOnLogInitPaymentProcess',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'quote_selected' : quote_selected,
			'addons_selected' : addons_selected
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);

		return true;

	}

	async storeOnLogTryToPayWithCreditCardProcess(progress) {

		let data = {
			'log' : 'storeOnLogTryToPayWithCreditCardProcess',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'try_to_pay_with_credit_card' : true
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVgPaymentRegisterCreditCardProcess(adyenData, progress) {
		let data = {
			'log' : 'storeOnLogVgPaymentRegisterCreditCardProcess',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'adyenData' : adyenData
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogTryToPayWithIBANProcess(userFormData, progress) {
		let data = {
			'log' : 'storeOnLogTryToPayWithIBANProcess',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'IBAN_data' : userFormData
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogSetPaymentAgreementSepa(sepaData, progress) {
		let data = {
			'log' : 'storeOnLogSetPaymentAgreementSepa',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'sepa_data' : sepaData
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogProblemWithAnonymousStep4(progress) {
		let data = {
			'log' : 'storeOnLogProblemWithAnonymousStep4',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
		}

		await this.sendDataToStoreOnLog("Problems-Managed", data);
	}

	async storeOnLogProblemWithBasketId(progress) {
		let data = {
			'log' : 'storeOnLogProblemWithBasketId',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
		}

		await this.sendDataToStoreOnLog("Problems-Managed", data);
	}

	async storeOnLogProblemGender(gender, dataForm) {
		let data = {
			'log' : 'storeOnLogProblemGender',
			'gender' : gender,
			'dataForm' : dataForm
		}

		await this.sendDataToStoreOnLog("Problems-Managed", data);
	}

	async storeOnLogProblemWithBasketAnonymousToken(progress) {
		let data = {
			'log' : 'storeOnLogProblemWithBasketAnonymousToken',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
		}

		await this.sendDataToStoreOnLog("Problems-Managed", data);
	}

	async storeOnLogProblemGender(gender, dataForm) {
		let data = {
			'log' : 'storeOnLogProblemGender',
			'gender' : gender,
			'dataForm' : dataForm
		}

		await this.sendDataToStoreOnLog("Problems-Managed", data);
	}

	async storeOnLogVgPaymentIbanRegistered(updatedUserSepa, progress) {
		let data = {
			'log' : 'storeOnLogVgPaymentIbanRegistered',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'updated_User_Sepa' : updatedUserSepa
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVgFinishRegisterIbanProcessWithoutPayNow(progress, basketParams, shoppingBasketClosed) {
		let data = {
			'log' : 'storeOnLogVgFinishRegisterIbanProcessWithoutPayNow',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'basket_params' : basketParams,
			'shoppingBasketClosed' : shoppingBasketClosed
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVgFinishPayment(progress, data_to_storage) {
		let data = {
			'log' : 'storeOnLogVgFinishPayment',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
			'data' : data_to_storage,
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVGAnonymousForbiddenMethod(progress) {
		let data = {
			'log' : 'storeOnLogVGAnonymousForbiddenMethod',
			'external_Id' : progress.getUserExternalId(),
			'progress' : progress,
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVgEmptyBasket(progress) {
		let data = {
			'log' : 'storeOnLogVgEmptyBasket',
			'external_Id' : progress.getUserExternalId(),
			'progress' : progress,
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async storeOnLogVGAdyenNotLoaded(progress) {
		let data = {
			'log' : 'storeOnLogVGAdyenNotLoaded',
			'external_Id' : progress.getUserExternalId(),
			'gym_Id' : progress.getGymId(),
			'basket_key': progress.getBasket()?.shoppingBasketKey,
		}

		await this.sendDataToStoreOnLog("WP-Payment-Steps", data);
	}

	async sendDataToStoreOnLog(logName, data) {
		const api = new VgApiClient();
		api.action = "process_ajax_jc_log_no_short";
		api.params = {
			log_name: logName,
			data: data
		};

		return api
			.handleRequest()
			.then((data) => {
				if (data) {
					console.log("We store log correctly.");
				} else {
					console.error("We couldn't store log.");
				}
			})
			.catch((error) => {
				console.error("Network or API error to store Log:", error);
			});
	}
}

export { VgLogs };
